import type { ZodError } from 'zod'

/**
 * Achata as issues de um ZodError em uma linha legivel.
 *
 * O toString padrao do ZodError nao sobrevive ao console do navegador nem ao
 * Sentry: chega apenas "ZodError", sem dizer qual campo falhou.
 */
export function formatZodIssues(error: ZodError): string {
	return error.issues
		.map((issue) => {
			const path = issue.path.join('.')
			return path ? `${path}: ${issue.message}` : issue.message
		})
		.join('; ')
}
